import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

var firebaseConfig = {
    apiKey: "AIzaSyBboqZzlY692-JeSObcOGYPvvUTOVvestc",
    authDomain: "adventour-17c81.firebaseapp.com",
    databaseURL: "https://adventour-17c81.firebaseio.com",
    projectId: "adventour-17c81",
    storageBucket: "adventour-17c81.appspot.com",
    messagingSenderId: "317690751422",
    appId: "1:317690751422:web:81771cdab91f029072b1ef",
    measurementId: "G-8GB7QX7HG0",
    logErrors: false
};

firebase.initializeApp(firebaseConfig);

export const fb = firebase;
export const db = firebase.firestore()